export default {
  autoComplete: '/admin/api/fluids/fluid-class-auto-complete',
  data: '/admin/api/fluids',
  export: '/admin/api/fluids/export',
  deletePrecheck: '/admin/api/fluids/delete-check'
};
